import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  tone?: 'dark' | 'light';
}
export function SectionHeading({
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-168" data-mp="3f2n5xuqe6mpf">
      <h2 className={`font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl ${isDark ? 'text-white' : 'text-brand-ink'}`} data-id="element-169" data-mp="3jzx2duc77ymr">
        {title}
      </h2>
      {subtitle && <p className={`mx-auto mt-4 max-w-2xl text-base font-bold leading-relaxed sm:text-lg ${isDark ? 'text-white/75' : 'text-brand-ink/70'}`} data-id="element-170" data-mp="gjzsznlv2uph">
          {subtitle}
        </p>}
    </div>;
}